const PLACEHOLDER = '{APP_API_PATH}';

const getWindowConfig = () => {
    if (typeof window === 'undefined') {
        return {};
    }

    return window.__TRACKER_CONFIG__ || {};
};

const getEnvFallback = () => process.env.REACT_APP_API_PATH || '';

export const getApiPath = () => {
    const runtimeValue = getWindowConfig().REACT_APP_API_PATH;

    if (runtimeValue && runtimeValue !== PLACEHOLDER) {
        return runtimeValue;
    }

    return getEnvFallback();
};
